import React, { Component } from "react";
import { getTableConfigKekurangan } from "../configs/config";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../modules/custom/customTable";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import { FormatCurrencyWithoutSymbol } from "../../../../Services/Utils";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";

class KekuranganSODetail extends Component {
  basedColumn = [
    {
      name: "nilaiBeli",
      label: "Nilai Beli",
      options: {
        customBodyRender: (val) => {
          return (
            <div style={{ width: "100px" }}>
              <SimpleInput
                box="number"
                readOnly
                value={FormatCurrencyWithoutSymbol({ number: val })}
              />
            </div>
          );
        },
        sort: false,
      },
    },
    {
      name: "nilaiBeliDiakui",
      label: "Nilai Beli Diakui",
      options: {
        customBodyRender: (val, { rowIndex }) => {
          return (
            <>
              <SimpleInput
                box="number"
                readOnly={this.disabledExclude(rowIndex) || this.props.selectedData.stockOpnameStatus === "COMPLETED"}
                value={FormatCurrencyWithoutSymbol({ number: val })}
                onValueChange={({ value }) =>
                  this.props.handleChangeNilaiDiakui(
                    value,
                    rowIndex,
                    this.props.tab
                  )
                }
              />
            </>
          );
        },
        sort: false,
      },
    },
    {
      name: "nilaiDibebankanKaryawan",
      label: "Nilai Dibebankan Karyawan",
      options: {
        customBodyRender: (val, { rowIndex }) => {
          return (
            <>
              <SimpleInput
                box="number"
                readOnly={this.disabledExclude(rowIndex) || this.props.selectedData.stockOpnameStatus === "COMPLETED"}
                value={FormatCurrencyWithoutSymbol({ number: val })}
                onValueChange={({ value }) =>
                  this.props.handleChangeNilaiKaryawan(
                    value,
                    rowIndex,
                    this.props.tab
                  )
                }
              />
            </>
          );
        },
        sort: false,
      },
    },
    {
      name: "nilaiDibebankanPerusahaan",
      label: "Nilai Dibebankan Perusahaan",
      options: {
        customBodyRender: (value) => {
          return (
            <>
              <SimpleInput
                box="number"
                readOnly
                value={FormatCurrencyWithoutSymbol({ number: value })}
              />
            </>
          );
        },
        sort: false,
      },
    },
    {
      name: "exclude",
      label: "Exclude",
      options: {
        customBodyRender: (value, { rowIndex }) => {
          return (
            <>
              <SimpleCheckBox
                checked={value}
                disabled={this.props.selectedData.stockOpnameStatus === "COMPLETED"}
                onChange={({ target }) =>
                  this.props.handleExclude(
                    target.checked,
                    rowIndex,
                    this.props.tab
                  )
                }
              />
            </>
          );
        },
        sort: false,
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      tableColumn: [],
      pagination:{
          limit: 5,
          page: 1,
          totalData: 0
      }
    };
  }

  componentDidMount() {
    console.log(this.props);
    
    this.setState({
      tableColumn: [
        ...getTableConfigKekurangan(
          this.props.tab,
          this.props.controls.stockOpnameType?.value?.value || null
        ),
        ...this.basedColumn,
      ],
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.controls.stockOpnameType !== this.props.controls.stockOpnameType
    ) {
      this.setState({
        tableColumn: [
          ...getTableConfigKekurangan(
            this.props.tab,
            this.props.controls.stockOpnameType?.value?.value || null
          ),
          ...this.basedColumn,
        ],
      });
    }
  }

  disabledExclude = (index) => {
    let variableDataName =
      this.props.tab === "with_qr" ? "listDataQR" : "listDataTanpaQR";
    return this.props.state.dataKekurangan[variableDataName][index].exclude;
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };

  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    return (
      <>
        {this.props.tab === "with_qr" && (
          <SimpleDataTable
            key={`${this.props.state.dataKekurangan.listDataQR?.length}-${this.state.pagination.page}`}
            data={this.props.state.dataKekurangan.listDataQR}
            columns={this.state.tableColumn}
            toCount={this.props.state.dataKekurangan.listDataQR.length}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
          />
        )}
        {this.props.tab === "without_qr" && (
          <SimpleDataTable
            key={`${this.props.dataKekurangan?.listDataTanpaQR?.length}-${this.state.pagination.page}`}
            data={this.props.state.dataKekurangan?.listDataTanpaQR}
            columns={this.state.tableColumn}
            toCount={this.props.state.dataKekurangan?.listDataTanpaQR.length}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
          />
        )}
        <div id="total" className={"grid grid-3x margin-top-10px"}>
          <div id="grid-1" />
          <div id="grid-2" />
          <div id="grid-3">
            <SimpleInput
              style
              label={"Total Dibebankan Karyawan: "}
              value={FormatCurrencyWithoutSymbol({
                number:
                  this.props.tab === "with_qr"
                    ? this.props.state.dataKekurangan.totalDibebankanKaryawanQR
                    : this.props.state.dataKekurangan
                        .totalDibebankanKaryawanTanpaQR,
              })}
            />
            <SimpleInput
              label={"Total Dibebankan Perusahaan: "}
              value={FormatCurrencyWithoutSymbol({
                number:
                  this.props.tab === "with_qr"
                    ? this.props.state.dataKekurangan
                        .totalDibebankanPerusahaanQR
                    : this.props.state.dataKekurangan
                        .totalDibebankanPerusahaanTanpaQR,
              })}
            />
            <SimpleInput
              label={"Total: "}
              value={FormatCurrencyWithoutSymbol({
                number:
                  this.props.tab === "with_qr"
                    ? this.props.state.dataKekurangan.totalQR
                    : this.props.state.dataKekurangan.totalTanpaQR,
              })}
            />

            <SimpleInput
              label={"Grand Total: "}
              value={FormatCurrencyWithoutSymbol({
                number: this.props.state.dataKekurangan.grandTotal,
              })}
            />
          </div>
        </div>
        <FlexView style={{ justifyContent: "end", marginTop: "10px" }}>
          <SimpleButton
            secondary={this.props.selectedData.stockOpnameStatus === "COMPLETED"}
            disabled={this.props.selectedData.stockOpnameStatus === "COMPLETED"}
            onClick={this.props.handleSubmit}
          >
            Resolve
          </SimpleButton>
        </FlexView>
      </>
    );
  }
}

export default KekuranganSODetail;
